export default __webpack_public_path__ + "static/media/vc.999bddbf.jpg";